import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLTextField, PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import Table from './Table';
import NewModal from '../../Modals/Videos/NewModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllVideosView extends Component {
    
    constructor( props ) {
        super( props );
        
        let search = undefined;
        if( this.props.location.state && this.props.location.state.search ) {
            search = this.props.location.state.search;
        }

        this.state = {
            fetching: true,
            newModal: false,
            rows: [],
            searchValue: search || '',
        };
        
        this.queryObject = {
            sort: '-id',
            search,
            page: 1,
            limit: 10,
        };
    }
    componentDidMount() {
        this.loadContent();
    }
    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.queryObject.search = this.state.searchValue || undefined;
            this.queryObject.page = 1;
            this.props.history.replace( { pathname: this.props.location.pathname, search: '', state: {
                isActive: true,
                search: this.queryObject.search,
            } } );
            this.setState( {
                fetching: true,
                rows: [],
            } );
            this.loadContent();
        }
    }
    onColumnSort = ( value ) => {
        if( this.queryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.queryObject.sort = value;
        this.queryObject.page = 1;
        this.setState( {
            fetching: true,
            rows: [],
        } );
        this.loadContent();
    }

    loadContent= () => {
        return this.props.getRows( this.queryObject )
        .then( ( rows ) => {
            this.queryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.rows = prevState.rows.concat( rows );
                return prevState;
            } );
            return rows;
        } );
    }

    dataUpdated = ( index, qrcode ) => {
        this.setState( ( altState ) => {
            if( qrcode !== null ) {
                altState.rows[ index ] = qrcode;
            } else {
                altState.rows.splice( index, 1 );
            }
            altState.rows = altState.rows.slice( 0 );
            return altState;
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }

    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }

    onNewModalSubmit = ( newQRCode ) => {
        this.setState( ( altState ) => {
            altState.rows.unshift( newQRCode );
            altState.rows = altState.rows.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, rows, searchValue } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Videos</h2>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                        <PrimaryButton
                        label='+ Create Video'
                        style={ { width: '200px' } }
                        onClick={ this.openNewModal } />
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allPage }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <Table
                            rows={ rows }
                            loadMore={ this.loadContent }
                            currentSort={ this.queryObject.sort }
                            onColumnSort={ this.onColumnSort }
                            onDataUpdated={ this.dataUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getRows: ( queryObject ) => {
            return dAPI.get( '/admin/videos', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllVideosView );
